import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/versiones-vehiculares/';

/**
 * GET versiones vehiculares
 * @param {object} params
 * @returns {Promise<Array<object>>}
 */
export const getVersionesVehiculares = async (params = null) => {
  try {
    const response = await API.get('/catalogos/versiones-vehiculares/', { params });
    return { ...response.data, results: formatReceived(response.data.results) };
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Version Vehicular
 * @param {number} id
* @returns {Promise<Array<object>>}
 */
export const getVersionVehicular = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Version Vehicular
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postVersionVehicular = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Version Vehicular
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchVersionVehicular = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Version Vehicular
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteVersionVehicular = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
